module.exports = __webpack_public_path__ + "img/ico_ts_assistant@2x.1d7e5008.png";